module.exports = __webpack_public_path__ + "img/03吴向军.4aca195a.png";